import { Link } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  return (
    <section className="bg-[#fffaf5] py-24">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-8">
        <article className="rounded-3xl border border-orange-100 bg-white p-6 shadow-sm sm:p-8 lg:p-10">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-orange-600">Legal</p>
          <h1 className="mt-2 text-4xl font-semibold text-slate-900">Privacy Policy</h1>
          <p className="mt-3 text-sm text-slate-600">
            This Privacy Policy explains how Haapa Store collects, uses, and protects your personal information.
          </p>

          <div className="mt-8 space-y-8 text-sm leading-7 text-slate-700">
            <section>
              <h2 className="text-xl font-semibold text-slate-900">Personal information we collect</h2>
              <p className="mt-2">We collect personal information about you in the following ways:</p>
              <h3 className="mt-4 text-base font-semibold text-slate-900">Information you give us</h3>
              <ul className="mt-2 list-disc space-y-2 pl-6">
                <li>Personal and business contact information, such as first name, last name, postal address, email address, and phone number.</li>
                <li>Profile information, such as username and password.</li>
                <li>Feedback, correspondence and reviews, including survey responses, support requests, and product reviews.</li>
                <li>Transaction information, such as purchases, registrations, and billing details. We do not collect or store card numbers or other payment credentials.</li>
                <li>Usage information about how you use the site and interact with us.</li>
              </ul>

              <h3 className="mt-4 text-base font-semibold text-slate-900">Information we get from others</h3>
              <p className="mt-2">
                We may receive information from analytics providers and other sources and combine it with information we collect through our services.
              </p>

              <h3 className="mt-4 text-base font-semibold text-slate-900">Information automatically collected</h3>
              <p className="mt-2">
                When you access our site, we may log technical and usage data such as device type, browser, language, screen size, pages viewed, time spent, access times, and referring pages. We use cookies and local storage for this.
              </p>

              <h3 className="mt-4 text-base font-semibold text-slate-900">Automated Decision Making</h3>
              <p className="mt-2">
                We do not use your personal data for automated decision-making. If required by law in the future, we will notify you and provide an opportunity to object.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Changes to your personal information</h2>
              <p className="mt-2">
                Keep your profile details accurate and current. You can update your registration profile if your personal information changes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">How we use your personal information</h2>
              <h3 className="mt-3 text-base font-semibold text-slate-900">To provide our services</h3>
              <ul className="mt-2 list-disc space-y-2 pl-6">
                <li>Operate, maintain, administer, and improve the site.</li>
                <li>Manage and communicate with you regarding your account, including notices, updates, security alerts, and support messages.</li>
                <li>Understand your needs and personalize your experience.</li>
                <li>Provide support and maintenance.</li>
                <li>Respond to your requests, questions, and feedback.</li>
              </ul>

              <h3 className="mt-4 text-base font-semibold text-slate-900">To communicate with you</h3>
              <p className="mt-2">
                If you register, request information, or participate in surveys/events, we may send service and marketing communications as permitted by law. You may opt out at any time.
              </p>

              <h3 className="mt-4 text-base font-semibold text-slate-900">To comply with law</h3>
              <p className="mt-2">
                We may process personal information to comply with applicable laws, legal requests, and lawful process.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Your choices</h2>
              <h3 className="mt-3 text-base font-semibold text-slate-900">Access, update, correct, or delete your information</h3>
              <p className="mt-2">
                Account holders may review, update, correct, or delete personal information by signing in. You may also contact us for additional requests.
              </p>

              <h3 className="mt-4 text-base font-semibold text-slate-900">Choosing not to share personal information</h3>
              <p className="mt-2">
                If required information is not provided, we may be unable to provide services and may need to close your account. Required fields are marked in the service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Security</h2>
              <p className="mt-2">
                We apply organizational, technical, and physical safeguards to protect personal data during transmission and storage. No method is 100% secure, and absolute security cannot be guaranteed.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Children</h2>
              <p className="mt-2">
                Our services are not directed to children under 18. If a parent or guardian identifies unauthorized data submission by a child, please contact us and we will delete it as soon as reasonably practicable.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Sensitive personal data</h2>
              <p className="mt-2">
                Please do not submit sensitive personal data (such as social security numbers, health data, biometrics, genetic data, political or religious beliefs, criminal history, or union membership) through the site.
              </p>
              <p className="mt-2">
                If you choose to submit sensitive personal data, you consent to processing in line with this policy. If you do not consent, do not submit it.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Other sites and services</h2>
              <p className="mt-2">
                Our site may link to third-party websites and services. We are not responsible for their privacy practices and encourage you to review their policies.
              </p>
            </section>
          </div>

          <div className="mt-10 flex flex-wrap gap-3 border-t border-orange-100 pt-6">
            <Link to="/terms-of-use" className="rounded-xl bg-orange-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-orange-700">
              View Terms of Use
            </Link>
            <Link to="/" className="rounded-xl border border-orange-200 px-4 py-2 text-sm font-semibold text-orange-700 transition hover:bg-orange-50">
              Back Home
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
};

export default PrivacyPolicyPage;
